import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdfiOutreachLogsService } from '../../services/cdfi-outreach-logs.service';
import { CDFIOutreachEmail } from '../../models/cdfi-outreach-log';
import { DestroyBase } from '../../../../../shared/base-classes/destroy-component-base';
import { takeUntil } from 'rxjs';
import { PopupComponent } from '../../../../../shared/components/popup/popup.component';

@Component({
  selector: 'app-email-events-popup',
  standalone: true,
  imports: [CommonModule, PopupComponent],
  templateUrl: './email-events-popup.component.html',
  styleUrl: './email-events-popup.component.scss',
})
export class EmailEventsPopupComponent extends DestroyBase implements OnInit {
  @Input({ required: true }) outreachId!: number;
  @Input({ required: true }) businessName!: string;
  @Output() popupClosed = new EventEmitter<void>();

  loading = true;
  emailData: CDFIOutreachEmail | null = null;
  errorMessage = '';

  private cdfiOutreachLogsService = inject(CdfiOutreachLogsService);

  ngOnInit(): void {
    this.loadEmailEvents();
  }

  loadEmailEvents(): void {
    this.loading = true;
    this.cdfiOutreachLogsService
      .getCdfiOutreachEmailEvents(this.outreachId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.emailData = response;
          this.loading = false;
        },
        error: (error) => {
          this.errorMessage = 'Failed to load email events. Please try again.';
          this.loading = false;
          console.error('Error loading email events:', error);
        },
      });
  }

  closePopup(): void {
    this.popupClosed.emit();
  }

  getStatusClass(status: string): string {
    const statusLower = status.toLowerCase();

    if (
      statusLower.includes('bounced') ||
      statusLower.includes('bounce') ||
      statusLower.includes('dropped') ||
      statusLower.includes('drop') ||
      statusLower.includes('blocked') ||
      statusLower.includes('failed') ||
      statusLower.includes('deferred')
    ) {
      return 'status-error';
    }

    if (
      statusLower.includes('delivered') ||
      statusLower.includes('processed') ||
      statusLower.includes('submitted')
    ) {
      return 'status-success';
    }

    if (statusLower.includes('opened') || statusLower.includes('click')) {
      return 'status-info';
    }

    if (statusLower.includes('queued') || statusLower.includes('pending')) {
      return 'status-warning';
    }

    return 'status-default';
  }

  formatStatus(status: string): string {
    return status
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  get reversedEvents() {
    return this.emailData?.events ? [...this.emailData.events].reverse() : [];
  }
}
